import { render } from "./AddNewAddress.vue?vue&type=template&id=1f90eb69&lang=html"
import script from "./AddNewAddress.vue?vue&type=script&lang=js"
export * from "./AddNewAddress.vue?vue&type=script&lang=js"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__